import memberApi from './member-api';

/**
 * Login do associado
 */
export const login = async (email, password) => {
  try {
    const response = await memberApi.post('/member/auth/login', { email, password });
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message || 'Erro ao fazer login. Verifique suas credenciais.';
    throw new Error(message);
  }
};

/**
 * Logout do associado
 */
export const logout = async () => {
  try {
    await memberApi.post('/member/auth/logout');
    return { success: true };
  } catch (error) {
    throw new Error('Erro ao fazer logout.');
  }
};

/**
 * Esqueci minha senha — envia link de redefinição
 */
export const forgotPassword = async (email) => {
  try {
    const response = await memberApi.post('/member/auth/forgot-password', { email });
    return response.data;
  } catch (error) {
    // Sempre retorna sucesso para evitar enumeração de emails
    return {
      message: 'Se o email existir em nossa base, você receberá instruções para redefinir sua senha.',
    };
  }
};

/**
 * Redefinir senha com token
 */
export const resetPassword = async (token, email, password, passwordConfirmation) => {
  try {
    const response = await memberApi.post('/member/auth/reset-password', {
      token,
      email,
      password,
      password_confirmation: passwordConfirmation,
    });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Erro ao redefinir senha. O link pode ter expirado.';
    throw new Error(message);
  }
};

/**
 * Cadastro de novo associado
 */
export const register = async (data) => {
  try {
    const response = await memberApi.post('/member/auth/register', data);
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Erro ao realizar cadastro.';
    const errors = error.response?.data?.errors || null;
    const err = new Error(message);
    err.validationErrors = errors;
    throw err;
  }
};

/**
 * Busca dados do associado autenticado
 */
export const getCurrentMember = async () => {
  try {
    const response = await memberApi.get('/member/auth/me');
    return response.data;
  } catch (error) {
    throw new Error('Erro ao buscar dados do associado.');
  }
};

/**
 * Busca perfil do associado
 */
export const getMemberProfile = async () => {
  try {
    const response = await memberApi.get('/member/profile');
    return response.data;
  } catch (error) {
    throw new Error('Erro ao buscar perfil.');
  }
};

/**
 * Atualiza perfil do associado
 */
export const updateMemberProfile = async (data) => {
  try {
    const response = await memberApi.put('/member/profile', data);
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Erro ao atualizar perfil.';
    throw new Error(message);
  }
};

/**
 * Envia a foto do associado autenticado
 * @param {File} file - A imagem a ser enviada
 * @returns {Promise} { message, member }
 */
export const uploadMemberPhoto = async (file) => {
  try {
    const formData = new FormData();
    formData.append('photo', file);

    const response = await memberApi.post('/member/photo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 30000,
    });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Erro ao enviar foto.';
    throw new Error(message);
  }
};
